(() => {
  const isNoise = (value) => {
    const message = String(value && value.message ? value.message : value || '');
    return message.includes('No Listener: tabs:outgoing.message.ready') ||
      message.includes('tabs:outgoing.message.ready') ||
      message.includes('A listener indicated an asynchronous response by returning true') ||
      message.includes('message channel closed before a response was received') ||
      (message.includes('cssRules') && message.includes('Cannot read properties of null'));
  };

  window.addEventListener('unhandledrejection', (event) => {
    if (isNoise(event.reason)) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
    }
  }, true);

  window.addEventListener('error', (event) => {
    if (isNoise(event.error) || isNoise(event.message)) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
    }
  }, true);
})();
